import { api } from "./document-category.generated";
import {
  DefinitionsFromApi,
  TagTypesFromApi
} from "@reduxjs/toolkit/dist/query/endpointDefinitions";

export type * from "./document-category.generated";

export namespace DocumentCategoryService {

  const generatedApi = api.enhanceEndpoints({ addTagTypes: ["DocumentCategories"] });

  type Definitions = DefinitionsFromApi<typeof generatedApi>;
  type TagTypes = TagTypesFromApi<typeof generatedApi>;

  export const enhancedApi = generatedApi.enhanceEndpoints<TagTypes, Definitions>({
    endpoints: {
      GetAllDocumentCategories(endpoint) {
        endpoint.providesTags = ["DocumentCategories"];
      },
      GetDocumentCategoryByDocId(endpoint) {
        endpoint.providesTags = ["DocumentCategories"];
      },
      CreateDocumentCategory(endpoint) {
        endpoint.invalidatesTags = ["DocumentCategories"];
      },
      UpdateDocumentCategory(endpoint) {
        endpoint.invalidatesTags = ["DocumentCategories"];
      },
      DeleteDocumentCategory(endpoint) {
        endpoint.invalidatesTags = ["DocumentCategories"];
      }
    }
  });

  export const {
    useGetAllDocumentCategoriesQuery,
    useLazyGetAllDocumentCategoriesQuery,
    useGetDocumentCategoryByDocIdQuery,
    useLazyGetDocumentCategoryByDocIdQuery,
    useCreateDocumentCategoryMutation,
    useUpdateDocumentCategoryMutation,
    useDeleteDocumentCategoryMutation
  } = enhancedApi;

}
